import React from "react";

// MUI
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

type Props = {
  handleModalClose: () => void;
};

function DialogButtons({ handleModalClose }: Props) {
  return (
    <Stack direction="row" justifyContent="flex-end" gap={3}>
      <Button variant="contained" onClick={handleModalClose}>
        Cancel
      </Button>
      <Button variant="contained" color="error" type="submit">
        Delete
      </Button>
    </Stack>
  );
}

export default DialogButtons;
